(() => {
  const DEFAULT_COLLAPSED_REM = 20;
  const FIT_TOLERANCE_PX = 4;

  class AkoCollectionSeo extends HTMLElement {
    constructor() {
      super();
      this._onSummaryClick = this._onSummaryClick.bind(this);
      this._measure = this._measure.bind(this);
      this._resizeObserver = null;
      this._fontsReadyHandler = null;
    }

    connectedCallback() {
      this._details = this.querySelector('.collection-seo-content__details');
      this._body = this.querySelector('.collection-seo-content__body');
      this._summary = this.querySelector('.collection-seo-content__summary');
      if (!this._details || !this._body || !this._summary) return;

      const parsed = parseInt(this.dataset.collapsedHeight, 10);
      const remPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      this._limitPx = (Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_COLLAPSED_REM) * remPx;

      this._summary.addEventListener('click', this._onSummaryClick);

      if ('ResizeObserver' in window) {
        this._resizeObserver = new ResizeObserver(this._measure);
        this._resizeObserver.observe(this._body);
      }

      if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
        this._fontsReadyHandler = () => this._measure();
        document.fonts.ready.then(this._fontsReadyHandler);
      }

      this._measure();
    }

    disconnectedCallback() {
      if (this._summary) this._summary.removeEventListener('click', this._onSummaryClick);
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
    }

    _onSummaryClick(event) {
      event.preventDefault();
      if (this._details.hasAttribute('data-fits')) return;
      this._details.toggleAttribute('data-collapsed');
    }

    _measure() {
      if (!this._body || !this._details) return;
      const fits = this._body.scrollHeight <= this._limitPx + FIT_TOLERANCE_PX;
      if (fits) {
        this._details.setAttribute('data-fits', '');
        this._details.removeAttribute('data-collapsed');
      } else {
        this._details.removeAttribute('data-fits');
      }
    }
  }

  if (!customElements.get('ako-collection-seo')) {
    customElements.define('ako-collection-seo', AkoCollectionSeo);
  }
})();
